import Marquee from "react-fast-marquee";
import { CLIENT_LOGOS } from "@/lib/data";

export default function TrustSection() {
  return (
    <section className="relative py-14 border-y border-white/5" data-testid="trust-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <p className="text-center font-inter text-[11px] uppercase tracking-[0.28em] text-white/40 mb-10">
          Top IT Companies in USA
        </p>
        <div className="marquee-mask">
          <Marquee gradient={false} speed={40} pauseOnHover>
            {CLIENT_LOGOS.map((name, i) => (
              <div key={`${name}-${i}`} className="mx-10 flex items-center">
                <span className="font-poppins text-2xl sm:text-3xl font-semibold text-white/30 tracking-tight hover:text-white/70 transition-colors">
                  {name}
                </span>
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
}
